import type { iCookieData, iCookieVehicle } from "./types";
import { useCookie } from "../../hooks/useCookie";
import { USER_COOKIE_LOCAL_DATA_ID } from "./static";

const useUpdateCookieData = () => {
  const [localCookieData, setLocalCookieData] = useCookie<iCookieData>(
    USER_COOKIE_LOCAL_DATA_ID,
    {} as iCookieData,
  );

  // ********************
  // Update vehicle configuration
  // ====================
  const updateCookieVehicleConfig = (
    vehicleId: string,
    materialCode: string,
    accessories?: string[],
  ) => {
    const newVehiclesCookie = localCookieData?.vehicles ?? [];

    const vehicleIndex = localCookieData?.vehicles?.findIndex(
      (vehicle: iCookieVehicle) => vehicle.model === vehicleId,
    );
    const newVehicleData = {
      model: vehicleId,
      materialCode,
      accessories,
    };

    if (vehicleIndex >= 0) {
      newVehiclesCookie.splice(vehicleIndex, 1, newVehicleData);
    } else {
      newVehiclesCookie.push(newVehicleData);
    }

    localCookieData.vehicles = newVehiclesCookie;
    setLocalCookieData(localCookieData);
  };

  // ********************
  // Update dealer sap code
  // ====================
  const updateCookieDealer = (sapCode: string) => {
    const data = { dealerSapCode: sapCode };
    localCookieData.dealer = data;
    setLocalCookieData(localCookieData);
  };

  // ********************
  // Update user name
  // ====================
  const updateCookieUser = (name?: string) => {
    const data = { name, skipInput: true };
    localCookieData.user = data;
    setLocalCookieData(localCookieData);
  };

  return {
    updateCookieVehicleConfig,
    updateCookieDealer,
    updateCookieUser,
  };
};

export default useUpdateCookieData;
